import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseService } from 'tms-web-shared';
import { CapacityLoad } from '../../../models';

@Injectable({
  providedIn: 'root',
})
// The rough-cut load board. Read-only: it reports what the plan implies and changes
// nothing - moving work about is the finite board in a later phase.
export class CapacityLoadService extends TmsWebBaseService {
  constructor() {
    super('CapacityLoad');
  }

  getLoad(fromDate: string, toDate: string): Observable<CapacityLoad[]> {
    return this.httpService.get<CapacityLoad[]>(`${this.apiUrl}/Load?fromDate=${fromDate}&toDate=${toDate}`);
  }
}
